import { SetNewPasswordResponse } from '../../../api/hub-responses/set-new-password-response';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';

export type SetNewEmailPasswordRequest = {
    expires: number,
    email: string,
    token: string,
    password: string,
    locale: string
}

export function setNewEmailPassword(data: SetNewEmailPasswordRequest): Promise<SetNewPasswordResponse> {
    const hubApi = getHubApi();
    return hubApi.setNewPassword(window.app.deviceIdentifier, data) as Promise<SetNewPasswordResponse>;
}
